import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Filter, RestClientList } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { environment } from '../../../../../environments/environment'
import { NewWorkBatch } from '../../../orders/batches/work-batch'
import { TerminalWorkBatch } from '../orders/terminal-work-batch'

export class TerminalBatchFilter {
  public static workOrderId(workOrderId: string): Filter {
    return new Filter('workOrderId', workOrderId)
  }

  public static workCenterId(workCenterId: string): Filter {
    return new Filter('workCenterId', workCenterId)
  }

  public static workStationId(workStationId: string): Filter {
    return new Filter('workStationId', workStationId)
  }

  public static includeUnstartable(includeUnstartable: boolean): Filter {
    return new Filter('includeUnstartable', String(includeUnstartable))
  }
}

@Injectable({
  providedIn: 'root',
})
export class TerminalBatchService extends RestClientList<TerminalWorkBatch, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/terminal-batches', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public createNew(newBatch: NewWorkBatch): Observable<TerminalWorkBatch> {
    return super.create(newBatch)
  }
}
